/** Zahlenwerte von CheckIn.Action in den Check-in-Listen der API (Backend: CheckInAction). */
export const CheckInActionCode = {
  CheckIn: 1,
  CheckOut: 2,
  OpenDoor: 3,
  UnlockDevice: 4,
  DeductPoints: 5
} as const;
